import { createLanguageAssertion } from './src/createLanguageAssertion';

/**
 * Detect if string match russian language.
 * Used BCP47 standard for locale names.
 */
export const isRuLanguageCode = createLanguageAssertion({ matches: [/^(ru(-[a-zA-Z]{2})?)$/] });
